export default __webpack_public_path__ + "static/4-fe81c26e1f651da05bad5f24ebec2b34.jpg";